module.exports = __webpack_public_path__ + "static/media/majorB3.7ac3089.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorB3.wav
// module id = D63k
// module chunks = 0